import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const MapPinStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M24 9.33398C30.6267 9.33398 36 14.7073 36 21.334C36 24.414 34.8266 27.214 32.9199 29.334H31.667C29.7203 29.334 26.8804 29.6541 26.0938 34.374L25.333 38.667H22.667L21.9062 34.374C21.1196 29.6541 18.2663 29.334 16.333 29.334H15.0801C13.1734 27.214 12 24.414 12 21.334C12 14.7073 17.3733 9.33398 24 9.33398ZM23.9863 11.6006C18.6132 11.6008 14.2666 15.9608 14.2666 21.334C14.2666 23.4006 14.9332 25.4007 16.1465 27.0674H17.667C20.5601 27.0675 22.6667 28.0806 24 30.0537C25.3333 28.0806 27.4533 27.0675 30.333 27.0674H31.8398C33.0665 25.4007 33.7197 23.4007 33.7197 21.334C33.7197 15.9607 29.3597 11.6006 23.9863 11.6006Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
